/**
 * Shape of the transaction Match filter. Originally a single-select of four
 * mutually-exclusive accrual-aware buckets (`isMatched` / `isNotMatched`
 * replacement); extended with two additional, independently OR'able values
 * for the *suggested* (not yet confirmed) accrual match state:
 *
 * - TRANSACTION: transaction-to-transaction match. For accrual entities,
 *   this is an `accrual_match` row with both transaction legs set; for
 *   non-accrual entities, this falls back to the legacy `pairedTransferId`
 *   transfer match.
 * - INVOICE: an `accrual_match` row with `invoiceLineItemId` set (a
 *   confirmed match).
 * - BILL: an `accrual_match` row with `billLineItemId` set (a confirmed
 *   match).
 * - NONE: no match. For accrual entities, no `accrual_match` row references
 *   the transaction; for non-accrual entities, `pairedTransferId IS NULL`.
 * - SUGGESTED_INVOICE: an `accrual_match_suggestion` row with a non-null
 *   `invoiceId` references the transaction on either leg — a candidate
 *   invoice match exists but has not been confirmed/approved yet. Not
 *   mutually exclusive with INVOICE/BILL/NONE (a transaction can carry a
 *   suggestion independent of its confirmed-match state), so this and
 *   SUGGESTED_BILL are OR'd against whatever else is selected rather than
 *   folded into the priority-ordered bucket set above.
 * - SUGGESTED_BILL: same as SUGGESTED_INVOICE, with a non-null `billId`.
 */
export enum TransactionMatchType {
    TRANSACTION = "TRANSACTION",
    INVOICE = "INVOICE",
    BILL = "BILL",
    NONE = "NONE",
    SUGGESTED_INVOICE = "SUGGESTED_INVOICE",
    SUGGESTED_BILL = "SUGGESTED_BILL",
}
